// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1__baac14050304d58093bb","cls2":"AccountMenu-cls2___428dc5617f5c89e30a9 AccountMenu-cls1__baac14050304d58093bb"};